import { CheckCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { Col, Descriptions, Row, Skeleton, Table } from "antd";
import ECard from "components/ECard";
import EDescription from "components/EDescription";
import InlineCopyable from "components/InlineCopyable";
import InlineTooltip from "components/InlineTooltip";
import { ColoredStatistic, Curl, numberFormat } from "components/Jarvis";
import SettlementInfoEdit from "components/SettlementInfoEdit";
import { useRef } from "react";
import { useQuery } from "react-query";

export default function MerchantInformationPage() {
  const RefEditSettlementInformation = useRef();
  const { data, isFetching, refetch, isFetched } = useQuery(
    ["merchant", "information"],
    () => {
      return Curl.get("/gateway/resources/information").then(
        (res) => res.payload
      );
    }
  );

  if (isFetching) {
    return <Skeleton active />;
  }

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ECard title={<>Basic Information </>}>
          <EDescription column={3}>
            <Descriptions.Item label="Code">{data.code}</Descriptions.Item>
            <Descriptions.Item />
            <Descriptions.Item />
            <Descriptions.Item label="Legal Name">
              {data.legal_name}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <InlineTooltip title="appears in our Hosted Payment Page for your customers' to easy to recognize">
                  Display Name
                </InlineTooltip>
              }
            >
              {data.display_name}
            </Descriptions.Item>
            <Descriptions.Item />
            <Descriptions.Item
              label={
                <InlineTooltip title="Your Developer will need this to connect to our Application Programming Interface (API)">
                  API Key
                </InlineTooltip>
              }
            >
              <InlineCopyable>{data.api_key}</InlineCopyable>
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <InlineTooltip title="Your Developer will need this to verify our Payment Notification Signature">
                  Secret
                </InlineTooltip>
              }
            >
              <InlineCopyable>{data.secret}</InlineCopyable>
            </Descriptions.Item>
            <Descriptions.Item />
            <Descriptions.Item label="Main Contact Name">
              {data.contact_main_name}
            </Descriptions.Item>
            <Descriptions.Item label="Main Contact Mobile">
              {data.contact_main_mobile}
            </Descriptions.Item>
            <Descriptions.Item label="Main Contact Email">
              {data.contact_main_email}
            </Descriptions.Item>
            <Descriptions.Item label="Main Finance Name">
              {data.contact_finance_name}
            </Descriptions.Item>
            <Descriptions.Item label="Main Finance Mobile">
              {data.contact_finance_mobile}
            </Descriptions.Item>
            <Descriptions.Item label="Main Finance Email">
              {data.contact_finance_email}
            </Descriptions.Item>
          </EDescription>
        </ECard>
      </Col>

      <Col span={24}>
        <SettlementInfoEdit
          ref={RefEditSettlementInformation}
          data={data}
          onChange={refetch}
        />
        <ECard
          title={<>Settlement Information </>}
          // extra={
          //   <EditOutlined
          //     onClick={() => {
          //       handleEditSettlementOnclick(data);
          //     }}
          //   />
          // }
        >
          <EDescription column={3}>
            <Descriptions.Item label="Beneficiary Name">
              {data.bank_account_name}
            </Descriptions.Item>
            <Descriptions.Item label="Beneficiary Account">
              {data.bank_account_number}
            </Descriptions.Item>
            <Descriptions.Item />
            <Descriptions.Item label="Settlement Period">
              {data.settlement_period}
            </Descriptions.Item>
            <Descriptions.Item label="Settlement Currency">
              {data.settlement_currency}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <InlineTooltip title="When total Settlement Amount achieve Minimum Settlement Amount, the Settlement Transaction will be created">
                  Minimum Settlement Amount
                </InlineTooltip>
              }
            >
              {numberFormat(data.settlement_min_amount)}
            </Descriptions.Item>
          </EDescription>
        </ECard>
      </Col>
      <Col span={24}>
        <ECard title="Channels">
          <Table
            dataSource={data.channels}
            rowKey={"id"}
            size="small"
            columns={[
              {
                title: "Name",
                align: "center",
                render: (item) => {
                  return item.name;
                },
              },
              {
                title: "Auto Surcharge",
                align: "center",
                render: (item) => {
                  return item.auto_surcharge ? (
                    <CheckCircleOutlined
                      style={{
                        color: "blue",
                      }}
                    />
                  ) : (
                    <MinusCircleOutlined
                      style={{
                        color: "red",
                      }}
                    />
                  );
                },
              },
              {
                title: "Rate",
                align: "right",
                render: (item) => {
                  return (
                    <ColoredStatistic
                      value={parseFloat(item.rate) * 100}
                      suffix={"%"}
                    />
                  );
                },
              },
              {
                title: "Status",
                align: "center",
                render: (item) => {
                  return item.status ? (
                    <CheckCircleOutlined
                      style={{
                        color: "blue",
                      }}
                    />
                  ) : (
                    <MinusCircleOutlined />
                  );
                },
              },
            ]}
          />
        </ECard>
      </Col>
    </Row>
  );
}
